import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
    },

    header: {
      padding: 12,

      '& .MuiTypography-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,

        '& svg': {
          width: 14,
          height: 14,
        },
      },
    },

    content: {
      flex: 1,
      padding: 12,

      '& .MuiOutlinedInput-inputMultiline': {
        minHeight: 160,
      },
    },
    contentInCreation: {
      display: 'flex',
      alignItems: 'center',
    },

    contentFields: {
      flexWrap: 'nowrap',
    },

    fieldset: {
      gap: '8px',
      '& .MuiFormControlLabel-root': {
        marginLeft: 1,
      },
    },
    fieldSetSwitchComponents: {
      border: `1px solid ${palette.borderGray}`,
      borderRadius: 4,
      padding: 5,
      margin: 0,
      height: 33,
      display: 'flex',
    },
    fieldSetSwitchText: {
      fontSize: 10,
      fontFamily: 'Roboto',
      color: palette.gray,
      lineHeight: 1,
      fontWeight: 400,
      letterSpacing: 1,
    },
    switchRoot: {
      padding: 0,
      margin: 0,
    },
    switchLabel: {
      fontSize: 14,
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    useNewFront: {
      fontSize: 12,
      fontWeight: 500,
    },
  });
